// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__JnaVO","btnPrimary":"Button_btnPrimary__uWnH6","btnSecondary":"Button_btnSecondary__+bbFF","btnDisabled":"Button_btnDisabled__X0G3C"};